import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { setNewDialog, setSettings } from "../../store/slices/dialogSlice";
import Select from "../../ui/Select/Select";
import Slider from "../../ui/Slider/Slider";
import styles from "./VerticalFilterPanel.module.scss";

const dataSlider = [
  {
    title: "Температура",
    subtitle: "",
    min: "0.01",
    max: "2",
    step: "0.01",
    value: "temperature",
    defaultData: "0.5",
  },
  {
    title: "Макс. токенов",
    subtitle: "",
    min: "1",
    max: "4095",
    step: "1",
    value: "maxLength",
    defaultData: "1024",
  },
  {
    title: "Тор Р",
    subtitle: "Количество наиболее вероятных слов",
    min: "0.01",
    max: "1",
    step: "0.01",
    value: "topP",
    defaultData: "1",
  },
  {
    title: "Штраф за частоту",
    subtitle: "Штраф за генерацию очень часто встречающиеся слова или фразы",
    min: "0.01",
    max: "2",
    step: "0.01",
    value: "frequencyPenalty",
    defaultData: "0",
  },
  {
    title: "Штраф за повторения",
    subtitle:
      "Штраф за повторение одинаковых предсказаний или с низким разнообразием",
    min: "0.01",
    max: "2",
    step: "0.01",
    value: "presencePenalty",
    defaultData: "0",
  },
];

export default function VerticalFilterPanel({ dialogs }) {
  const dispatch = useDispatch();
  const dataSelect = useSelector((state) => state.model.data);
  const assistants = useSelector((state) => state.assistant.dataAssistants);

  const newDialog = useSelector((state) => state.dialog.newDialog);
  const activeDialog = useSelector((state) => state.dialog.activeDialog);

  // const settings = useSelector((state) => state.dialog?.settings);

  const selectObserver = (val, name) => {
    if (newDialog) {
      let res = JSON.parse(JSON.stringify(newDialog));

      Object.defineProperty(res.settings, "modelId", {
        value: val,
      });

      assistants?.forEach((assistant) => {
        if (assistant.name === name) {
          Object.defineProperty(res.settings, "assistantId", {
            value: assistant.id,
          });
        }
      });

      dispatch(setNewDialog(res));
      return dispatch(setSettings(res.settings));
    }
    if (activeDialog) {
      let data = JSON.parse(JSON.stringify(activeDialog));
      Object.defineProperty(data.settings, "modelId", {
        value: val,
      });
      dispatch(setSettings(data));
    }
  };

  const sliderObserver = (val, name) => {
    if (newDialog) {
      let res = JSON.parse(JSON.stringify(newDialog));

      Object.defineProperty(res?.settings, name, {
        value: Number(val),
      });

      return dispatch(setNewDialog(res));
    }

    if (activeDialog) {
      let data = JSON.parse(JSON.stringify(activeDialog));
      Object.defineProperty(data.settings, name, {
        value: Number(val),
      });

      return dispatch(setSettings(data));
    }
  };

  return (
    <div className={styles.container}>
      <Select
        dataSelect={dataSelect}
        assistants={assistants}
        title="Модель/ассистент"
        selectObserver={selectObserver}
        settings={
          newDialog
            ? newDialog.settings
            : activeDialog
            ? activeDialog.settings
            : null
        }
      />
      {dataSlider.map((el, index) => {
        return (
          <Slider
            {...el}
            settings={
              newDialog
                ? newDialog.settings
                : activeDialog
                ? activeDialog.settings
                : null
            }
            idx={index}
            key={index}
            newDialog={newDialog}
            sliderObserver={sliderObserver}
          />
        );
      })}
    </div>
  );
}
